<template>
  <TabsLayout>
    <ElTabPane name="complex" label="效果报表"></ElTabPane>
    <ElTabPane name="realtime" label="实时数据"></ElTabPane>
  </TabsLayout>
</template>
<script>
import TabsLayout from '@/views/report/tabs-layout.vue'
export default {
  name: 'comprehensivereport',
  components: {
    TabsLayout
  },
  data() {
    return {
      currentRoute: ''
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    },
    getCurrent() {
      this.currentRoute = this.$route.name
      if (this.$route.name === 'comprehensivereport') this.changeRouter('complex')
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
<style lang="scss" scoped>
.c-content {
  position: relative;
}
</style>
